<div class="w-full overflow-y-auto h-full">
    <div class="w-full p-6">
        <!-- Métodos de Pagamento -->
        <div class="w-full py-6">
            <div class="flex w-full justify-between items-center">
                <div class="flex">
                    <div class="p-2 rounded-xl bg-green-100 ml-2 h-[40px]">
                        <mat-icon svgIcon="mat_solid:credit_card" class="icon-size-6 text-green-600"></mat-icon>
                    </div>
                    <div class="px-3">
                        <div class="w-full leading-10">
                            <span class="text-[17px] font-[500] font-remote">Cartões Salvos</span>
                        </div>
                    </div>
                </div>
                <button mat-button class="text-[#0061ff] font-inter text-[14px] font-[500]" (click)="openAddCardModal()">
                    <mat-icon class="icon-size-5 mr-1" [svgIcon]="'mat_solid:add'"></mat-icon>
                    Adicionar Cartão
                </button>
            </div>

            <div class="w-full p-4 space-y-4">
                <!-- Loading Skeleton -->
                <ng-container *ngIf="loading">
                    <div *ngFor="let _ of [1, 2]" class="p-4 border border-gray-200 rounded-xl">
                        <div class="flex justify-between items-start">
                            <div class="flex items-start gap-3">
                                <div class="w-10 h-10 bg-gray-200 rounded-lg animate-pulse"></div>
                                <div>
                                    <div class="flex items-center gap-2 mb-2">
                                        <div class="h-4 bg-gray-200 rounded-xl w-32 animate-pulse"></div>
                                        <div class="h-4 bg-gray-200 rounded-full w-14 animate-pulse"></div>
                                    </div>
                                    <div class="h-3 bg-gray-200 rounded-xl w-28 animate-pulse"></div>
                                </div>
                            </div>
                            <div class="flex gap-2">
                                <div class="w-8 h-8 bg-gray-200 rounded-lg animate-pulse"></div>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <!-- Empty State -->
                <div *ngIf="!loading && paymentMethods.length === 0" class="text-center py-8">
                    <mat-icon class="icon-size-12 text-gray-300" [svgIcon]="'mat_solid:credit_card'"></mat-icon>
                    <p class="text-gray-500 font-inter text-[14px] mt-2">Nenhum cartão cadastrado</p>
                </div>

                <!-- Cards List -->
                <ng-container *ngIf="!loading">
                    <div *ngFor="let card of paymentMethods"
                         class="p-4 border border-gray-200 rounded-xl hover:border-blue-300 transition-colors">
                        <div class="flex justify-between items-start">
                            <div class="flex items-start gap-3">
                                <div class="p-2 rounded-lg" [ngClass]="getBrandColor(card.brand).bg">
                                    <mat-icon class="icon-size-6"
                                              [ngClass]="getBrandColor(card.brand).text"
                                              [svgIcon]="'mat_solid:credit_card'"></mat-icon>
                                </div>
                                <div>
                                    <div class="flex items-center gap-2">
                                        <span class="text-[15px] font-inter font-[500] text-gray-900">
                                            {{ getBrandName(card.brand) }} •••• {{ card.last4 }}
                                        </span>
                                        <span *ngIf="card.is_default"
                                              class="px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 text-[11px] font-inter font-[500]">
                                            Padrão
                                        </span>
                                    </div>
                                    <span class="text-[13px] font-inter font-[400] text-gray-500">
                                        Expira em {{ formatExpiry(card.exp_month, card.exp_year) }}
                                    </span>
                                </div>
                            </div>
                            <div class="flex gap-2">
                                <button class="w-8 h-8 flex items-center justify-center rounded-lg hover:bg-gray-100"
                                        [disabled]="card.is_default"
                                        (click)="confirmDeletePaymentMethod(card)">
                                    <mat-icon class="icon-size-4"
                                              [ngClass]="card.is_default ? 'text-gray-300' : 'text-red-500'"
                                              [svgIcon]="'mat_outline:delete'"></mat-icon>
                                </button>
                            </div>
                        </div>
                    </div>
                </ng-container>
            </div>
        </div>

        <!-- Outros Métodos -->
        <div class="w-full py-6 border-t border-gray-200">
            <div class="flex w-full">
                <div class="p-2 rounded-xl bg-purple-100 ml-2 h-[40px]">
                    <mat-icon svgIcon="mat_solid:payments" class="icon-size-6 text-purple-600"></mat-icon>
                </div>
                <div class="px-3">
                    <div class="w-full leading-10">
                        <span class="text-[17px] font-[500] font-remote">Outros Métodos</span>
                    </div>
                </div>
            </div>

            <div class="w-full p-4 space-y-3">
                <!-- PIX -->
                <div class="p-4 border border-gray-200 rounded-xl">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-3">
                            <div class="p-2 rounded-lg bg-green-50">
                                <mat-icon class="icon-size-6 text-green-600" [svgIcon]="'mat_solid:qr_code'"></mat-icon>
                            </div>
                            <div>
                                <span class="text-[15px] font-inter font-[500] text-gray-900 block">PIX</span>
                                <span class="text-[13px] font-inter font-[400] text-gray-500">Pagamento instantâneo</span>
                            </div>
                        </div>
                        <span class="text-[12px] font-inter font-[400] text-green-600">Disponível</span>
                    </div>
                </div>

                <!-- Boleto -->
                <div class="p-4 border border-gray-200 rounded-xl">
                    <div class="flex items-center justify-between">
                        <div class="flex items-center gap-3">
                            <div class="p-2 rounded-lg bg-yellow-50">
                                <mat-icon class="icon-size-6 text-yellow-600" [svgIcon]="'mat_solid:receipt'"></mat-icon>
                            </div>
                            <div>
                                <span class="text-[15px] font-inter font-[500] text-gray-900 block">Boleto Bancário</span>
                                <span class="text-[13px] font-inter font-[400] text-gray-500">Vencimento em até 3 dias úteis</span>
                            </div>
                        </div>
                        <span class="text-[12px] font-inter font-[400] text-green-600">Disponível</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
